import React, { Component } from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import { Icon } from 'react-fa';
import { onEmailChange, onPasswordChange, login } from './../../actions/Auth/AuthActions';
import { Button, Card } from 'reactstrap';
import Image from './../../images/download.png';
import Logo from './../../images/Recykle Full logo.png';

class Login extends Component {
    constructor() {
        super();
        this.emailValidation = false;
        this.passwordValidation = false;
        this.state = { flag: 0 };
        this.keyPress = this.keyPress.bind(this);
    }

    onEmailChange(event) {
        this.props.onEmailChange(event);
    }

    onPasswordChange(event) {
        this.props.onPasswordChange(event);
    }

    disableButton() {
        if (this.emailValidation && this.passwordValidation) {
            return false;
        } else {
            return true;
        }
    }

    loginButtonPress() {
        const { emailLogin, passwordLogin } = this.props;
        this.props.login({ emailLogin, passwordLogin });
        this.setState({ flag: 1 });
    }

    keyPress(e) {
        const { emailLogin, passwordLogin } = this.props;
        if (e.keyCode === 13) {
            this.props.login({ emailLogin, passwordLogin });
            this.setState({ flag: 1 });
        }
    }

    renderIconEmail() {
        const { emailLogin } = this.props;
        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
        if (reg.test(emailLogin) === true) {
            this.emailValidation = true;
            return <Icon className="fa-check-circle" name="fa-check-circle" style={styles.successIconStyle} />;
        } else if (emailLogin.length >= 1) {
            this.emailValidation = false;
            return <Icon className="fa-times-circle" name="fa-times-circle" style={styles.failIconStyle} />;
        }
    }

    renderIconPassword() {
        const { passwordLogin } = this.props;
        if (passwordLogin.length >= 1 && passwordLogin.length < 8) {
            this.passwordValidation = false;
            return <Icon className="fa-times-circle" name="fa-times-circle" style={styles.failIconStyle} />;
        } else if (passwordLogin.length >= 8) {
            this.passwordValidation = true;
            return <Icon className="fa-check-circle" name="fa-check-circle" style={styles.successIconStyle} />;
        }
    }

    render() {
        return (
            <div className="App" style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
                <div style={{ display: 'flex', alignSelf: 'flex-start', margin: 10 }}>
                    <img
                        src={Image}
                        className="img-responsive"
                        style={{ width: 150, height: 50, marginBottom: 20 }}
                    />
                </div>
                <div className="row" style={{ height: 400, width: '100%' }}>
                    <div className="col" style={{ alignSelf: 'center' }}>
                        <img
                            src={Logo}
                            className="img-responsive"
                            style={{ width: 200, height: 50, marginBottom: 20 }}
                        />
                        <Card style={styles.cardStyle}>
                            <div style={{ paddingTop: 30 }}>
                                <input
                                    type="text"
                                    placeholder="UserName"
                                    style={styles.inputStyle}
                                    value={this.props.emailLogin}
                                    onChange={event => this.onEmailChange(event.target.value)}
                                />
                                {this.renderIconEmail()}
                            </div>
                            <div style={{ paddingTop: 30 }}>
                                <input
                                    type="password"
                                    placeholder="Password"
                                    style={styles.inputStyle}
                                    value={this.props.passwordLogin}
                                    onChange={event => this.onPasswordChange(event.target.value)}
                                    onKeyDown={this.keyPress}
                                />
                                {this.renderIconPassword()}
                            </div>
                            {
                                this.props.error !== '' && this.props.emailLogin === '' ?
                                    <span style={styles.errorTextStyle}>
                                            Enter valid Email and Password
                                        </span> : null
                            }
                            <div style={{ paddingTop: 30 }}>
                                {
                                    this.emailValidation === true && this.passwordValidation === true ?
                                        <Button
                                            style={styles.loginButtonStyle}
                                            onClick={() => { this.loginButtonPress(); }}
                                        >
                                            Login
                                        </Button>
                                        :
                                        <button type="button" className="btn btn-default" disabled="disabled">
                                            Login
                                        </button>
                                }
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = { 
    inputStyle: {
        borderTopWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        width: 280,
        height: 40,
        paddingLeft: 20,
        paddingRight: 5,
        outlineWidth: 0,
        fontFamily: 'Source Sans Pro'
    },
    cardStyle: {
        borderColor: '#7ed321',
        alignItems: 'center',
        padding: 30,
        width: '30%',
        margin: 'auto',
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    loginButtonStyle: {
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    },
    successIconStyle: {
        color: 'rgba(0, 183, 58, 0.8)',
        fontWeight: '100',
        borderBottomWidth: 0.5,
        borderBottomColor: '#979797',
        borderWidth: 0,
        alignSelf: 'flex-end',
        paddingBottom: 10,
        opacity: 1
    },
    failIconStyle: {
        color: 'rgba(249, 39, 39, 0.8)',
        fontWeight: '100',
        borderBottomWidth: 0.5,
        borderBottomColor: '#979797',
        borderWidth: 0,
        alignSelf: 'flex-end',
        paddingBottom: 10,
        opacity: 1
    },
    errorTextStyle: {
        fontSize: 14,
        color: 'red',
        fontFamily: 'Source Sans Pro',
        paddingTop: 10
    }
};

function mapStateToProps(state) {
    return {
        emailLogin: state.login.email,
        passwordLogin: state.login.password,
        error: state.login.text
    };
}

export default connect(mapStateToProps, { onEmailChange, onPasswordChange, login })(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js